import angular from "angular";

angular
    .module('accessControlCrud.module', [])
    .service('Module', ['$http', function ($http) {

        function uri(id, path) {
            let link = '/control-panel/modules';
            if (id) {
                link += '/' + id;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.store = function (params) {
            return $http.post(uri(), params);
        };

        this.update = function (id, params) {
            params['_method'] = 'PUT';
            return $http.post(uri(id), params);
        };

        this.delete = function (id) {
            return $http.post(uri(id), {'_method': 'DELETE'});
        };

    }]);

export default 'accessControlCrud.module';


// WEBPACK FOOTER //
// ./resources/assets/modules/access-control-crud/module.js